import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/hero.css';

const features = [
  { img:'https://res.cloudinary.com/drezxp44k/image/upload/v1777171350/sin_plastico1_ei2ffw.png',         text:'Sin Plástico' },
  { img:'https://res.cloudinary.com/drezxp44k/image/upload/v1777171350/ingrdientes_naturales_rz7yzi.png', text:'Ingredientes\nNaturales' },
  { img:'https://res.cloudinary.com/drezxp44k/image/upload/v1777171351/sin_parebenos_ipbjiy.png',         text:'Sin Parabenos\nSin Sulfatos' },
  { img:'https://res.cloudinary.com/drezxp44k/image/upload/v1777171350/sin_aceite_f06k2k.png',            text:'Sin Aceite\nde Palma' },
  { img:'https://res.cloudinary.com/drezxp44k/image/upload/v1777171350/crueltyfree_xqqqpd.png',           text:'Cruelty Free\nVegano' },
  { img:'https://res.cloudinary.com/drezxp44k/image/upload/v1777171350/artesanal1_ucftex.png',            text:'Artesanal' },
];

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero-background">
        <div className="hero-pattern" />
        <div className="hero-deco hero-deco-1" />
        <div className="hero-deco hero-deco-2" />
      </div>

      <div className="hero-content">
<div style={{ margin:'0 auto 24px', maxWidth:700, width:'100%' }}>
          <img
            src="https://res.cloudinary.com/dcbd2vdzn/image/upload/v1777389549/banner4_wa4dvo.png"
            alt="WAWITA TE CUIDA - Tu cuidas el planeta con WAWITA"
            style={{ width:'100%', height:'auto', borderRadius:16 }}
          />
        </div>

        <p className="hero-description">
          Productos 100% naturales, libres de crueldad animal para toda tu familia. El poder de la naturaleza en cada ingrediente.
        </p>

        <div className="hero-buttons">
          <Link to="/" onClick={() => setTimeout(() => document.getElementById("productos")?.scrollIntoView({behavior:"smooth"}), 100)} className="btn-hero-primary">Explorar productos</Link>
          <a href="https://wa.me/573113407979" target="_blank" rel="noreferrer" className="btn-hero-outline">Escríbenos</a>
        </div>

        <div className="hero-features">
          {features.map(f => (
            <div key={f.text} className="feature-item">
              <img src={f.img} alt={f.text} className="feature-img" />
              <span className="feature-text" style={{ whiteSpace:'pre-line' }}>{f.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
